// import MembershipMarkup from 'components/membership-markup'; 
import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
library.add(fal);

export const Bus = new Vue();